import {
  Button,
  IconInfo20,
} from '@lightspeed/unified-components-helios-theme/react'
import { InventoryProvider, ProductModal } from '@vend/business-components'
import { useT } from '@transifex/react'
import React from 'react'
import {
  LineItemProductDetailsButtonProps,
  useLineItemProductDetailsButtonModel,
} from './useLineItemProductDetailsButtonModel'

export const LineItemProductDetailsButton = (
  props: LineItemProductDetailsButtonProps
) => {
  const t = useT()
  const model = useLineItemProductDetailsButtonModel(props)

  return (
    <>
      <Button
        type="button"
        prefixSlot={<IconInfo20 />}
        appearance="ghost"
        onClick={model.openProductModal}
        customClasses={{ container: 'w-full' }}
        customDataAttributes={{
          container: { 'data-track': 'show-inventory-and-details' },
        }}
      >
        {t('Show Inventory & Details')}
      </Button>

      {model.isProductModalOpen ? (
        <InventoryProvider config={model.inventoryConfig}>
          <ProductModal
            productId={props.productId}
            onClose={model.closeProductModal}
          />
        </InventoryProvider>
      ) : null}
    </>
  )
}
